import { Box } from "arkh";
import React from "react";

export function ArchivedController(props: {
  archived: boolean;
  archivedCard: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <>
      {props.archived ? (
        <Box spaceBottom="large">{props.archivedCard}</Box>
      ) : null}
      <Box
        style={{
          opacity: props.archived ? 0.4 : 1,
          pointerEvents: props.archived ? "none" : "auto",
        }}
      >
        {props.children}
      </Box>
    </>
  );
}
